export const KEY_EMB_WEB_VITAL_NAME = 'emb.web_vital.name';
export const KEY_EMB_WEB_VITAL_VALUE = 'emb.web_vital.value';
export const KEY_EMB_WEB_VITAL_RATING = 'emb.web_vital.rating';
export const KEY_EMB_WEB_VITAL_DELTA = 'emb.web_vital.delta';
export const KEY_EMB_WEB_VITAL_ID = 'emb.web_vital.id';
export const KEY_EMB_WEB_VITAL_NAVIGATION_TYPE =
  'emb.web_vital.navigation_type';
export const KEY_EMB_WEB_VITAL_ATTRIBUTION_PREFIX =
  'emb.web_vital.attribution.';
